import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      Paid for by the Texas House Democratic&nbsp;Caucus, texashousedems.com.{' '}
      <br />Not created with government&nbsp;funds.<br /><br />The data from this analysis comes from Every Texan, a statewide non-partisan policy organization. This analysis details the projected loss of funding to Texas public school districts should 1%, 3%, or 5% of students accept a voucher — you can learn more about our data and methodology <a href="https://everytexan.org/89th-legislative-session-voucher-loss-analysis/" target="_blank" rel="noopener noreferrer">here</a>. While Every Texan resources are publicly available, Every Texan was not involved in the creation of this website.
    </div>
  </footer>
);

export default Footer; 